import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GetPromotionDetailsUseCase } from '@/core/domain/promotion-details/usecases/getPromotionsDetails.usecase';
import { PromotionDetailsRepository } from '@/core/domain/promotion-details/repositories/promotion-details.repository';
import { PromotionDetailsImplRepository } from './promotion-details-impl.repository';

const getPromotionDetailsUseCaseFactory = (
    promotionDetailsRepository: PromotionDetailsRepository,
) => new GetPromotionDetailsUseCase(promotionDetailsRepository);

@NgModule({
    imports: [CommonModule],
    providers: [
        {
            provide: GetPromotionDetailsUseCase,
            useFactory: getPromotionDetailsUseCaseFactory,
            deps: [PromotionDetailsRepository],
        },
        {
            provide: PromotionDetailsRepository,
            useClass: PromotionDetailsImplRepository,
        },
    ],
})
export class PromotionDetailsDataModule {}
